export default __webpack_public_path__ + "static/media/Arrow-mobile.9ca37e28.svg";